import {
  CONVERSATION_PARTICIPATING_EXCLUSIVE_BLOCKS,
  CONVERSATION_PARTICIPATING_PERMISSIONS,
  CONVERSATION_PERMISSION_SUPERSEDES,
  MANAGE_ALL_CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';

export const getPermissionDisabledState = (
  selectedPermissions,
  permission,
  { participatingExclusive = false } = {}
) => {
  const hierarchySuperseder = Object.entries(
    CONVERSATION_PERMISSION_SUPERSEDES
  ).find(
    ([activePermission, supersededPermissions]) =>
      selectedPermissions.includes(activePermission) &&
      supersededPermissions.includes(permission)
  );

  if (hierarchySuperseder) {
    return { blockedBy: hierarchySuperseder[0], reason: 'hierarchy' };
  }

  if (
    participatingExclusive &&
    selectedPermissions.includes(CONVERSATION_PARTICIPATING_PERMISSIONS) &&
    !selectedPermissions.includes(MANAGE_ALL_CONVERSATION_PERMISSIONS) &&
    CONVERSATION_PARTICIPATING_EXCLUSIVE_BLOCKS.includes(permission)
  ) {
    return {
      blockedBy: CONVERSATION_PARTICIPATING_PERMISSIONS,
      reason: 'exclusive',
    };
  }

  return null;
};

export const getSupersedingPermission = (
  selectedPermissions,
  permission,
  options = {}
) =>
  getPermissionDisabledState(selectedPermissions, permission, options)
    ?.blockedBy ?? null;

export const isPermissionSuperseded = (
  selectedPermissions,
  permission,
  options = {}
) =>
  getPermissionDisabledState(selectedPermissions, permission, options) !== null;

export const stripSupersededPermissions = (
  selectedPermissions,
  { participatingExclusive = false } = {}
) => {
  const result = selectedPermissions.filter(
    permission =>
      !getPermissionDisabledState(selectedPermissions, permission, {
        participatingExclusive,
      })
  );

  if (
    participatingExclusive &&
    result.includes(CONVERSATION_PARTICIPATING_PERMISSIONS) &&
    !result.includes(MANAGE_ALL_CONVERSATION_PERMISSIONS)
  ) {
    return [CONVERSATION_PARTICIPATING_PERMISSIONS];
  }

  return result;
};
